import React from "react";
import { PlanDetailsContextProvider } from "./PlanDetailsView";
import PlanDetails from "./views/PlanDetails";

const SubscriptionPlanDetailsPage = () => {
  return (
    <PlanDetailsContextProvider>
      <PlanDetails />
    </PlanDetailsContextProvider>
  );
};

export default SubscriptionPlanDetailsPage;
